/**
 * A role's permissions grouped the way Team & Roles shows them (2026-08-19): by catalog category with its human label,
 * and anything outside the catalog (custom.* or legacy keys) in "other". Moved out of ./RoleDetailPanel.tsx (PV14 part
 * 2a, 2026-10-09) so the new design's onboarding groups a role exactly as today's panel and the invite modal do without
 * importing today's styled panel.
 */
import { PERMISSION_CATALOG_UI } from '../../constants/permissionCatalog';

/** What a role's detail panel reads of a role. */
export interface RoleDetailPanelRole {
  name: string;
  description?: string;
  effectivePermissions?: string[];
  grants?: string[];
}

/** Group a role's permission keys by catalog category (human labels);
 *  anything outside the catalog (custom.* / legacy) lands in "other". */
export function groupPermissionsByCategory(
  keys: string[],
): Array<{ label: string; items: string[] }> {
  const perms = new Set(keys);
  const groups: Array<{ label: string; items: string[] }> = [];
  for (const cat of PERMISSION_CATALOG_UI) {
    const items = cat.permissions.filter((p) => perms.has(p.key)).map((p) => p.label);
    if (items.length) groups.push({ label: cat.label, items });
    cat.permissions.forEach((p) => perms.delete(p.key));
  }
  if (perms.size) groups.push({ label: 'other', items: Array.from(perms) });
  return groups;
}
